const normalizeAccountNumber = (value) => String(value ?? '')
  .toUpperCase()
  .replace(/[^A-Z0-9]/g, '');

export const findImportAccountMatches = (accountNumber, accounts) => {
  const normalized = normalizeAccountNumber(accountNumber);
  if (!normalized) return [];

  const exactMatches = accounts.filter(
    (account) => normalizeAccountNumber(account.account_number) === normalized,
  );
  if (exactMatches.length > 0 && !/^\d{4}$/.test(normalized)) return exactMatches;

  const lastFour = normalized.match(/\d{4}$/)?.[0];
  if (!lastFour) return [];

  return accounts.filter((account) => (
    normalizeAccountNumber(account.account_number).match(/\d{4}$/)?.[0] === lastFour
  ));
};
